import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';

const API_URL = 'https://fifty-two-in-the-lou-production.up.railway.app/api';

const ProfileModal = ({ onClose }) => {
  const { theme } = useTheme();
  const { user } = useAuth();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [notificationPreference, setNotificationPreference] = useState('push');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const getAuthHeader = () => {
    const u = JSON.parse(localStorage.getItem('user'));
    return { Authorization: `Bearer ${u?.token}` };
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await fetch(`${API_URL}/users/me`, {
        method: 'PUT',
        headers: { ...getAuthHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber, notificationPreference })
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      setError('Failed to save. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '12px',
    borderRadius: '8px',
    border: `2px solid ${theme.border}`,
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: '0.95rem',
    boxSizing: 'border-box'
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000, padding: '20px'
    }}>
      <div style={{
        backgroundColor: theme.cardBackground,
        borderRadius: '16px',
        width: '100%',
        maxWidth: '480px',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
      }}>
        <div style={{
          backgroundColor: theme.headerBackground,
          padding: '16px 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h2 style={{ color: theme.headerText, margin: 0, fontSize: '1.1rem' }}>My Profile</h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none',
            color: theme.headerText, fontSize: '1.5rem', cursor: 'pointer'
          }}>✕</button>
        </div>

        <div style={{ padding: '20px' }}>
          <p style={{ color: theme.subText, fontSize: '0.85rem', marginBottom: '16px' }}>
            Logged in as <strong style={{ color: theme.text }}>{user?.username}</strong>
          </p>

          {error && <p style={{ color: '#ef4444', fontSize: '0.85rem', marginBottom: '10px' }}>{error}</p>}

          <p style={{ color: theme.text, fontWeight: '700', marginBottom: '6px', fontSize: '0.9rem' }}>
            Phone Number (optional)
          </p>
          <input
            type="tel"
            placeholder="e.g. 314-555-1234"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={inputStyle}
          />

          <p style={{ color: theme.text, fontWeight: '700', marginBottom: '6px', fontSize: '0.9rem' }}>
            Notification Preference
          </p>
          <select
            value={notificationPreference}
            onChange={(e) => setNotificationPreference(e.target.value)}
            style={inputStyle}
          >
            <option value="push">Push Notifications</option>
            <option value="email">Email Only</option>
            <option value="both">Both</option>
            <option value="none">None</option>
          </select>

          <button
            onClick={handleSave}
            style={{
              width: '100%', padding: '12px', borderRadius: '8px', border: 'none',
              backgroundColor: saved ? '#22c55e' : theme.buttonPrimary,
              color: theme.buttonText,
              fontWeight: '700', cursor: 'pointer', fontSize: '0.9rem'
            }}
          >
            {saving ? 'Saving...' : saved ? '✅ Saved!' : 'Save Profile'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
